var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.8,0H25H4.3C1.9,0,0,1.9,0,4.3V25v20.8C0,48.1,1.9,50,4.3,50H25h20.8c2.3,0,4.3-1.9,4.3-4.3V25V4.3 C50,1.9,48.1,0,45.8,0z M20,38c-3.4,0-6.5-1-9.2-2.7c0.4,0.1,1,0.1,1.4,0.1c2.8,0,5.4-1,7.5-2.6c-2.6,0-4.9-1.7-5.7-4.1 c0.3,0.1,0.8,0.1,1.1,0.1c0.5,0,1.1-0.1,1.6-0.2C14,28,12,25.7,12,22.7c0,0,0,0,0-0.1c0.8,0.4,1.7,0.8,2.7,0.8 c-1.6-1.1-2.7-2.9-2.7-5c0-1.1,0.3-2.2,0.8-3c2.9,3.7,7.4,6.1,12.4,6.3C25,21.2,25,20.8,25,20.2c0-3.4,2.7-6,6-6 c1.7,0,3.3,0.8,4.3,1.8c1.4-0.2,2.6-0.8,3.8-1.4c-0.4,1.4-1.4,2.6-2.6,3.4c1.2-0.1,2.4-0.4,3.5-1c-0.5,1.2-1.6,2.2-2.8,3.1 C37.6,28.2,31.4,38,20,38z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f21f78fcde6b7afc53efc34f94f5a06a.svg";
export { ForwardRef as ReactComponent };